import React from 'react'
import { ErrorMessage, Field } from 'formik';
import { Tooltip } from './tooltip';

export const LeftContent = ({ 
    openAccordion, 
    openAccordions, 
    pageContentForm, 
    values, 
    setFieldValue,
    errors,
    touched,
    setEmail,
    setContinuationPopActived,
    setFieldTouched
}) => {
    return (
        <div className="page-contact__form--left">
            <div className="grid col-2 col-1-md gap-30 gap-md-none">
                <div className="form-field">
                    <label htmlFor="name">{pageContentForm.pageLanguage !== null ? 'Tu Nombre' : 'Your Name'}</label>
                    <Field type="text" id="name" name="name" />
                    <ErrorMessage className="text-white form-field--err" name="name" component="div" />
                </div>
                <div className="form-field">
                    <label htmlFor="phoneNumber">{pageContentForm.pageLanguage !== null ? 'Número de Teléfono' : 'Phone Number'}</label>
                    <Field type="tel" id="phoneNumber" name="phoneNumber" />
                    <ErrorMessage className="text-white form-field--err" name="phoneNumber" component="div" />
                </div>
            </div>
            <div className="grid col-2 col-1-md gap-30 gap-md-none">
                <div className="form-field">
                    <label htmlFor="email">{pageContentForm.pageLanguage !== null ? 'Correo Electrónico' : 'Email address'}</label>
                    <Field type="email" id="email" name="email" />
                    <ErrorMessage className="text-white form-field--err" name="email" component="div" />
                </div>
                <div className="form-field">
                    <label htmlFor="company">{pageContentForm.pageLanguage !== null ? 'Compañía' : 'Company'}</label>
                    <Field type="text" id="company" name="company" />
                    <ErrorMessage className="text-white form-field--err" name="company" component="div" />
                </div>
            </div>
            <div className="grid col-2 col-1-md gap-30 gap-md-none">
                <div className="location-services">
                    <div className="form-field">
                        <label htmlFor="location">{pageContentForm.pageLanguage !== null ? 'Ubicación' : 'Location'}</label>
                        <Field type="text" id="location" name="location" />
                        <ErrorMessage className="text-white form-field--err" name="location" component="div" />
                    </div>
                    <div className="form-field--service">
                        <p>{pageContentForm.pageLanguage !== null ? 'Selecciona el/los tema(s) de interés:' : 'Select subject(s) of interest:'}</p>
                        <div role="group" aria-labelledby="checkbox-group" className="form-field--service__radio">
                            <Tooltip tooltip={pageContentForm.tooltip} openAccordion={openAccordion} openAccordions={openAccordions} />
                            {values.checked.includes('Other') && (
                                <div className="form-field">
                                    <Field type="text" id="other" name="other" />
                                    <ErrorMessage className="text-white form-field--err" name="picked" component="div" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="message-upload">
                    <div className="form-field">
                        <label htmlFor="message">{pageContentForm.pageLanguage !== null ? 'Mensaje' : 'Message'}</label>
                        <Field as="textarea" id="message" name="message" />
                        <ErrorMessage className="text-white form-field--err" name="message" component="div" />
                    </div>
                    <div className="form-field form-field--upload">
                        <label htmlFor="file">{pageContentForm.pageLanguage !== null ? 'Subir Archivo' : 'Upload File'}</label>
                        <input
                            id="file"
                            className="form-field--upload__input"
                            name="file"
                            type="file"
                            onChange={(event) => {
                                setFieldValue("file", event.currentTarget.files[0]);
                            }}
                        />
                        <span className={`bold text-white form-field--upload__note`}>{pageContentForm.pageLanguage !== null ? '(Solo formato PDF. El tamaño del archivo no debe superar los 15 MB por documento.)' : '(PDF format only. File size should not surpass 15 MB per document.)'}</span>
                        <ErrorMessage className="text-white form-field--err" name="file" component="div" />
                    </div>
                    <div className="form-button">
                        <button
                            className="btn btn-brand-color"
                            type="button"
                            onClick={() => {
                                if (Object.keys(errors).length === 0 && Object.values(touched).length > 0) {
                                    setEmail(values.email);
                                    setContinuationPopActived(true);
                                } else {
                                    // Mark fields as touched to trigger error messages
                                    ['name', 'phoneNumber', 'email', 'company', 'location', 'message'].forEach(field =>
                                        setFieldTouched(field, true, true)
                                    );
                                }
                            }}
                        >
                            {pageContentForm.pageLanguage !== null ? '+ ENVIAR TU CONSULTA' : '+ SUBMIT YOUR INQUIRY'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}